"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
// Widget wrapper that adds a dropdown menu in a gear floating
const DropdownWidgetComponent = (props) => {
    const { width, height, dropdownItems, children } = props;
    const dropdownRef = (0, react_1.useRef)(null);
    const renderDropdownItem = (item, i) => {
        return (react_1.default.createElement("li", { key: `${i}` },
            react_1.default.createElement("a", { className: "dropdown-item", onClick: item.onClick }, item.label)));
    };
    const renderDropdown = () => {
        if (dropdownItems.length === 0) {
            return null;
        }
        const dropdownStyle = {
            position: "absolute",
            right: 3,
            top: 3,
            cursor: "pointer",
            zIndex: 1029
        };
        return (react_1.default.createElement("div", { style: dropdownStyle, ref: dropdownRef },
            react_1.default.createElement("div", { style: dropdownStyle, "data-bs-toggle": "dropdown" },
                react_1.default.createElement("div", { className: "mwater-visualization-simple-widget-gear-button" },
                    react_1.default.createElement("span", { className: "fas fa-cog" }))),
            react_1.default.createElement("ul", { className: "dropdown-menu dropdown-menu-end", style: { top: 25 } }, dropdownItems.map(renderDropdownItem))));
    };
    const closeMenu = (0, react_1.useCallback)(() => {
        if (dropdownRef.current) {
            const dropdownToggle = dropdownRef.current.querySelector('[data-bs-toggle="dropdown"]');
            if (dropdownToggle) {
                dropdownToggle.parentElement?.classList.remove('open');
            }
        }
    }, []);
    return (react_1.default.createElement("div", { className: "mwater-visualization-simple-widget", onMouseLeave: closeMenu, style: { width, height } },
        children,
        renderDropdown()));
};
exports.default = DropdownWidgetComponent;
